import type { StateTree } from '@makemydeal/dr-dash-types';

export const isOnSaveValidationFlow = (state: StateTree) => Boolean(state.saveValidation?.isOnSaveFlow);
